export default "__VITE_ASSET__BjZj4Dv7__"